import{getDefaultExportFromCjs as e}from"./_commonjsHelpers.mjs";import{__require as o}from"../international_address_autocomplete/Suggestion.mjs";var r=e(o());export{r as default};
